(() => {
  const provinces = {
    Canada: [['Alberta','AB'],['British Columbia','BC'],['Manitoba','MB'],['New Brunswick','NB'],['Newfoundland and Labrador','NL'],['Northwest Territories','NT'],['Nova Scotia','NS'],['Nunavut','NU'],['Ontario','ON'],['Prince Edward Island','PE'],['Quebec','QC'],['Saskatchewan','SK'],['Yukon','YT']],
    'United States': [['Alabama','AL'],['Alaska','AK'],['Arizona','AZ'],['Arkansas','AR'],['California','CA'],['Colorado','CO'],['Connecticut','CT'],['Delaware','DE'],['District of Columbia','DC'],['Florida','FL'],['Georgia','GA'],['Hawaii','HI'],['Idaho','ID'],['Illinois','IL'],['Indiana','IN'],['Iowa','IA'],['Kansas','KS'],['Kentucky','KY'],['Louisiana','LA'],['Maine','ME'],['Maryland','MD'],['Massachusetts','MA'],['Michigan','MI'],['Minnesota','MN'],['Mississippi','MS'],['Missouri','MO'],['Montana','MT'],['Nebraska','NE'],['Nevada','NV'],['New Hampshire','NH'],['New Jersey','NJ'],['New Mexico','NM'],['New York','NY'],['North Carolina','NC'],['North Dakota','ND'],['Ohio','OH'],['Oklahoma','OK'],['Oregon','OR'],['Pennsylvania','PA'],['Rhode Island','RI'],['South Carolina','SC'],['South Dakota','SD'],['Tennessee','TN'],['Texas','TX'],['Utah','UT'],['Vermont','VT'],['Virginia','VA'],['Washington','WA'],['West Virginia','WV'],['Wisconsin','WI'],['Wyoming','WY']]
  };

  const isFrench = (root) => (root?.dataset.locale || '').toLowerCase().startsWith('fr');
  const copy = (root, en, fr) => isFrench(root) ? fr : en;

  function fillProvinces(root) {
    if (!root) return;
    const country = root.querySelector('[data-shipping-country]');
    const province = root.querySelector('[data-shipping-province]');
    if (!country || !province) return;
    province.innerHTML = (provinces[country.value] || []).map(([name, code]) => `<option value="${code}">${name}</option>`).join('');
    if (country.value === 'Canada') province.value = 'QC';
  }

  async function estimate(form, root) {
    const result = root.querySelector('[data-shipping-result]');
    const country = root.querySelector('[data-shipping-country]').value;
    const province = root.querySelector('[data-shipping-province]').value;
    const zip = root.querySelector('[data-shipping-zip]').value.trim();
    result.textContent = copy(root, 'Calculating rates…', 'Calcul des tarifs…');
    const params = new URLSearchParams({
      'shipping_address[country]': country,
      'shipping_address[province]': province,
      'shipping_address[zip]': zip
    });
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${base}cart/shipping_rates.json?${params}`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('rates');
      const rates = (await response.json()).shipping_rates || [];
      if (!rates.length) {
        result.textContent = copy(root, 'No rate found for this postal code.', 'Aucun tarif trouvé pour ce code postal.');
        return;
      }
      const currency = window.Shopify?.currency?.active || 'CAD';
      result.innerHTML = `<ul>${rates.map((rate) => {
        const amount = new Intl.NumberFormat(copy(root, 'en-CA', 'fr-CA'), { style: 'currency', currency }).format(Number(rate.price));
        return `<li><span>${rate.name}</span><b>${amount}</b></li>`;
      }).join('')}</ul>`;
    } catch (error) {
      result.textContent = copy(root, 'Rates could not be calculated. Continue to checkout to confirm shipping.', 'Les tarifs n’ont pas pu être calculés. Passez au paiement pour confirmer la livraison.');
    }
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-shipping-country]')) return;
    fillProvinces(event.target.closest('[data-bhind-cart-tools]'));
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-shipping-form]')) return;
    event.preventDefault();
    if (!event.target.reportValidity()) return;
    estimate(event.target, event.target.closest('[data-bhind-cart-tools]'));
  });

  const initialize = () => document.querySelectorAll('[data-bhind-cart-tools]').forEach(fillProvinces);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();


if (!customElements.get('bhind-upsell')) {
  customElements.define('bhind-upsell', class BhindUpsell extends HTMLElement {
    connectedCallback() {
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
      document.addEventListener('cart:refresh', this.refreshBound ||= () => this.refresh());
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.refreshBound) document.removeEventListener('cart:refresh', this.refreshBound);
    }

    async refresh() {
      try {
        const response = await fetch((window.routes?.cart_url || '/cart') + '.js', { credentials: 'same-origin' });
        if (!response.ok) return;
        this.render(await response.json());
      } catch (error) {
        console.warn('BHIND upsell could not refresh', error);
      }
    }

    render(cart) {
      this.renderShipping(cart);
      this.renderPackout(cart);
    }

    text(en, fr) {
      return (this.dataset.locale || '').toLowerCase().startsWith('fr') ? fr : en;
    }

    money(cents, currency) {
      const locale = this.text('en-CA', 'fr-CA');
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(cents / 100);
    }

    renderShipping(cart) {
      const currency = (cart.currency || '').toUpperCase();
      const threshold = currency === 'CAD' ? 15000 : currency === 'USD' ? 10000 : null;
      const box = this.querySelector('[data-shipping]');
      if (!box || !threshold) return;

      const total = Number(cart.total_price || 0);
      const remaining = Math.max(0, threshold - total);
      const percent = Math.min(100, Math.round((total / threshold) * 100));
      const title = this.querySelector('[data-shipping-title]');
      const message = this.querySelector('[data-shipping-message]');
      const bar = this.querySelector('[data-shipping-bar]');
      const progress = this.querySelector('.bhind-progress');

      title.textContent = remaining > 0
        ? this.text('Free shipping goal', 'Objectif livraison gratuite')
        : this.text('Free shipping unlocked', 'Livraison gratuite débloquée');

      message.textContent = remaining > 0
        ? this.text(
            'Only ' + this.money(remaining, currency) + ' away from free shipping.',
            'Plus que ' + this.money(remaining, currency) + ' avant la livraison gratuite.'
          )
        : this.text('Your order qualifies.', 'Votre commande est admissible.');

      bar.style.width = percent + '%';
      progress.setAttribute('aria-valuenow', String(percent));
      box.hidden = false;
    }

    classify(item) {
      const title = String(item.product_title || '').toLowerCase();
      const variant = String(item.variant_title || '').toUpperCase();
      let family = null;
      if (title.includes('8431') || title.includes('8436')) family = 'compact';
      else if (title.includes('8430') || title.includes('8435')) family = 'large';
      if (!family) return null;

      if (title.includes('center bin')) {
        return { family: 'large', type: 'CB', units: item.quantity * (variant.includes('DUO') ? 2 : 1) };
      }

      const model = variant.split('/').pop().trim();
      if (model.startsWith('SB')) return { family, type: 'SB', units: item.quantity };
      if (model.startsWith('LB')) return { family, type: 'LB', units: item.quantity };
      return null;
    }

    counts(cart) {
      const result = { large: { SB: 0, LB: 0, CB: 0 }, compact: { SB: 0, LB: 0, CB: 0 } };
      (cart.items || []).forEach((item) => {
        const entry = this.classify(item);
        if (entry) result[entry.family][entry.type] += entry.units;
      });
      return result;
    }

    renderPackout(cart) {
      const box = this.querySelector('[data-packout]');
      const target = this.querySelector('[data-packout-families]');
      if (!box || !target) return;

      if (this.dataset.mode !== 'product' || !this.dataset.family) {
        box.hidden = true;
        target.innerHTML = '';
        return;
      }

      const counts = this.counts(cart);
      const families = [this.dataset.family];

      this.querySelector('[data-packout-title]').textContent =
        this.text('Complete your PACKOUT', 'Complétez votre PACKOUT');
      this.querySelector('[data-packout-subtitle]').textContent =
        this.text('See what is still missing at a glance.', 'Voyez en un coup d’œil ce qu’il manque encore.');

      target.innerHTML = families.map((family) => this.familyMarkup(family, counts[family])).join('');
      box.hidden = false;
    }

    familyMarkup(family, current) {
      const large = family === 'large';
      const capacity = large ? { SB: 8, LB: 2, CB: 2 } : { SB: 4, LB: 1 };
      const label = large
        ? this.text('Large case · 8430 / 8435', 'Grande valise · 8430 / 8435')
        : this.text('Compact case · 8431 / 8436', 'Petite valise · 8431 / 8436');
      const totalFilled = Object.keys(capacity).reduce((sum, key) => sum + Math.min(current[key], capacity[key]), 0);
      const totalCapacity = Object.values(capacity).reduce((sum, value) => sum + value, 0);

      return '<section class="bhind-packout-family">' +
        '<div class="bhind-packout-family__title"><span>' + label + '</span><span>' +
        totalFilled + ' / ' + totalCapacity + '</span></div>' +
        '<div class="bhind-capacity-grid">' +
        Object.entries(capacity).map(([type, max]) => this.capacityMarkup(family, type, current[type], max)).join('') +
        '</div></section>';
    }

    capacityMarkup(family, type, count, max) {
      const filled = Math.min(count, max);
      const missing = Math.max(0, max - count);
      const complete = missing === 0;
      const url = family === 'compact'
        ? this.dataset.compactUrl
        : type === 'CB' ? this.dataset.cbUrl : this.dataset.largeUrl;
      const slots = Array.from({ length: max }, (_, index) =>
        '<span class="bhind-capacity__slot' + (index < filled ? ' is-filled' : '') + '"></span>'
      ).join('');
      const action = complete
        ? this.text('Complete', 'Complet')
        : this.text('Choose ' + type, 'Choisir ' + type);
      const detail = complete
        ? action
        : this.text(missing + ' missing', 'Il en manque ' + missing);

      return '<div class="bhind-capacity' + (complete ? ' is-complete' : '') + '">' +
        '<div class="bhind-capacity__top"><span>' + type + '</span><span>' + count + ' / ' + max + '</span></div>' +
        '<div class="bhind-capacity__slots" aria-hidden="true">' + slots + '</div>' +
        (complete ? '<span>' + detail + '</span>' : '<a href="' + url + '">' + detail + ' · ' + action + '</a>') +
        '</div>';
    }
  });
}